import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { ChatOptions, Comment } from '@app/core/components/chat/chat.component';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CustactDialogsGet, CustactService, GetCustactParams } from '@app/services/custact.service';
import { ActivityStatusItem, EconomyService } from '@app/services/economy.service';

@Component({
    selector: 'tt-custact-dialogs',
    templateUrl: './custact-dialogs.component.html',
    styleUrls: ['./custact-dialogs.component.css'],
})
export class CustactDialogsComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetCustactParams;

    @Output()
    public submit = new EventEmitter<void>();

    public get?: CustactDialogsGet;

    public chatOptions: ChatOptions<CustactComment> = {
        keynames: {
            commentKeyno: 'custactdialog_keyno',
        },
        fetch: {
            save: {
                method: 108,
                parameters: () => ({ ...this.get }),
            },
            get: {
                method: 107,
                parameters: () => ({ custact_no: this.get?.custact_no }),
            },
            delete: {
                method: 3001,
            },
        },
    };

    public activityStatuses: ActivityStatusItem[] = [];

    public noteButtons: FormButton[] = [{ id: 'goto', icon: 'far fa-chevron-right', type: 'primary', tooltip: 'goto', translateTooltip: true, goto: 'workdetails', gotoParms: () => this.get?.custact_no || '' }];

    constructor(
        private custact: CustactService,
        private economy: EconomyService,
        private cdr: ChangeDetectorRef,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public onActivityStatusChanged(event: string) {
        const status = this.activityStatuses.find((actstatus) => actstatus.actstatus_keyno === event);

        if (!!this.get && !!status && status.set_ok === '1') {
            this.get.ok = '1';
        }
        this.markForChange();
    }

    private async loadActivityStatuses() {
        if (!!this.get) {
            this.activityStatuses = await this.economy.getActivityStatuses({ activitytype_no: this.get.activitytype_no });
            this.markForChange();
        }
    }

    public async loadGet() {
        if (!!this.params && typeof this.params === 'object' && 'custact_no' in this.params && !isNaN(+this.params.custact_no)) {
            this.get = await this.custact.getCustactDialogsPage(this.params);
        }
        this.markForChange();
    }

    public markForChange() {
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        setTimeout(() => {
            this.cdr.markForCheck();
            this.cdr.detectChanges();
        });
    }

    private async init() {
        await this.loadGet();
        this.navigator?.setHeading?.(this.get?.note ?? '');
        this.loadActivityStatuses();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: 'min(98vw, 140rem)', height: '95vh' });
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}

interface CustactComment extends Comment {
    custactdialog_keyno: string | number;
}
